import { render } from "./SettingsIndex.vue?vue&type=template&id=709870fe"
import script from "./SettingsIndex.vue?vue&type=script&lang=js"
export * from "./SettingsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script